var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-version": _vm.version }, attrs: { id: "externalHeader" } },
    [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _vm.version
        ? _c("div", { staticClass: "version" }, [
            _c("span", { staticClass: "mobile-only" }, [_vm._v("v")]),
            _vm._v(_vm._s(_vm.version))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "header-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "login",
          on: {
            click: function($event) {
              _vm.openLink(_vm.appUrl)
            }
          }
        },
        [_vm._v("LOGIN")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a61a068", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a61a068","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalHeader.vue
// module id = 641
// module chunks = 4